/**
 * Start loading the submenu card images as soon as the menu drawer opens.
 *
 * The images are `loading="lazy"` so they cost nothing on page load, but lazy
 * images inside a hidden submenu panel only start downloading once the panel
 * slides into view. Switching them to eager when the drawer opens gives them
 * the drawer's open animation and the time before a category is tapped to
 * download, so the cards appear with their images.
 */
document.addEventListener(
  'toggle',
  (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;
    if (details.id !== 'Details-menu-drawer-container' || !details.open) return;

    for (const image of details.querySelectorAll('img.pacc-submenu-card__image[loading="lazy"]')) {
      image.loading = 'eager';
    }
  },
  // `toggle` does not bubble; listen in the capture phase to see it on <details>
  true
);
